export default {"src":"/_next/static/media/mask_fast_match_searching_screen.0ee63a1b.svg","height":112,"width":414,"blurWidth":0,"blurHeight":0};